import { type ErrorDetail } from './types';

// TODO : Add type to apiErrorManagerGlobal
declare global {
  var apiErrorManagerGlobal: any;
}

class ApiErrorTracker {
  private lastErrors: ErrorDetail[] = [];
  private subscribers: Array<(isActive: boolean) => void> = [];

  appendError(error: Omit<ErrorDetail, 'isActive'>): void {
    const newError: ErrorDetail = {
      ...error,
      isActive: true
    };
    this.lastErrors.push(newError);
    this.notifySubscribers();
  }

  getErrors(): ErrorDetail[] {
    return this.lastErrors;
  }

  // Once error is copied on clipboard hide the error button and clear out the error array
  clearError(): void {
    this.lastErrors = []; // Clear all errors
    this.notifySubscribers();
  }

  // Track and append api error
  trackFailedApi(
    url: string,
    error: any,
    traceId: string,
    payload?: any
  ): void {
    const errorDetail = {
      url,
      apiUrl: error?.config?.url || url,
      traceId: traceId || error?.headers?.['x-request-id'],
      timestamp: new Date().toISOString(),
      errorDetails: error,
      payload
    };
    this.appendError(errorDetail);
  }

  subscribe(callback: (isActive: boolean) => void): () => void {
    this.subscribers.push(callback);
    callback(this.lastErrors.some((error) => error.isActive));

    return () => {
      this.subscribers = this.subscribers.filter((cb) => cb !== callback);
    };
  }

  private notifySubscribers() {
    this.subscribers.forEach((callback) => {
      callback(this.lastErrors.some((error) => error.isActive));
    });
  }
}

if (!globalThis.apiErrorManagerGlobal) {
  globalThis.apiErrorManagerGlobal = new ApiErrorTracker();
}

const apiErrorManager = globalThis.apiErrorManagerGlobal;

export default apiErrorManager;
